import React from "react";
import { motion } from "framer-motion";
import { Check, Sparkles } from "lucide-react";
import { HABIT_PLAN } from "../content";

export default function HabitPlan() {
  return (
    <section
      id="habit-plan"
      data-testid="habit-plan-section"
      className="relative section-pad"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-5 lg:sticky lg:top-32"
          >
            <div className="text-[#27C6FF] uppercase tracking-[0.3em] text-xs mb-5 font-heading">
              Habit Building Plan
            </div>
            <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.05]">
              Become the most{" "}
              <span className="gradient-text">consistent version</span> of
              yourself.
            </h2>
            <p className="mt-6 text-[#D8CCFF] text-base md:text-lg font-body">
              {HABIT_PLAN.tagline}
            </p>

            <div className="mt-8 glass-strong rounded-2xl p-5 border-l-2 border-[#27C6FF]">
              <div className="flex items-start gap-3">
                <Sparkles size={16} className="text-[#27C6FF] mt-0.5 flex-shrink-0" />
                <p className="text-[#CFAEFF] text-xs md:text-sm leading-relaxed">
                  {HABIT_PLAN.disclaimer}
                </p>
              </div>
            </div>

            <a
              href="#booking"
              data-testid="habit-plan-cta"
              className="mt-8 inline-flex btn-primary px-7 py-3.5 rounded-full font-heading font-semibold"
            >
              Enrol in the Habit Plan
            </a>
          </motion.div>

          <div className="lg:col-span-7">
            <div className="grid sm:grid-cols-2 gap-4">
              {HABIT_PLAN.items.map((item, i) => (
                <motion.div
                  key={item}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.2 }}
                  transition={{ duration: 0.5, delay: i * 0.04 }}
                  whileHover={{ y: -3 }}
                  className="glass rounded-2xl p-5 flex items-start gap-3.5 hover:neon-aqua transition-shadow duration-500"
                  data-testid={`habit-item-${i}`}
                >
                  <span className="mt-0.5 w-7 h-7 rounded-full bg-gradient-to-br from-[#7A2BFF] to-[#27C6FF] flex items-center justify-center flex-shrink-0 shadow-[0_0_18px_rgba(122,43,255,0.45)]">
                    <Check size={14} className="text-white" />
                  </span>
                  <span className="text-[#F5F3FF] text-sm md:text-base font-body leading-relaxed">
                    {item}
                  </span>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
